import { PageProvider } from '@/core/context/PageContext';
import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import React from 'react';
import { useTableFilter } from '@/core/hooks/useTableFilter';
import GetDetailCourse from '../viewmodels/course-detail.viewmodel';
import GetListCourse from '../viewmodels/course-list.viewmodel';

export const CourseProvider = (props: any) => {
  const {
    courseData: detailCourse,
    actionGetDetailCourse,
    loading: loadingDetail,
    error: errorDetail,
  } = GetDetailCourse();

  const { courseData, actionGetAllCourse, loading, error } = GetListCourse();

  const [currentQueryParameters] = useSearchParams();
  const getId = currentQueryParameters.get('id');

  const { methodFilter } = useTableFilter({
    handleFetchData: actionGetAllCourse,
    querySearch: { name: '', shortName: '' },
    queryFilters: { isActive: undefined, numberOfSession: undefined, sessionHour: undefined },
    queryPagination: { page: 1, limit: 10 },
  });

  const { control, setValue, reset, getValues, watch } = methodFilter;

  useEffect(() => {
    actionGetAllCourse(getValues());
  }, []);

  useEffect(() => {
    if (getId) {
      actionGetDetailCourse(getId);
    }
  }, [getId]);

  const data = {
    detailCourse,
    actionGetDetailCourse,
    loadingDetail,
    errorDetail,
    courseData,
    actionGetAllCourse,
    loading,
    error,
    control,
    setValue,
    reset,
    getValues,
    watch,
  };

  return <PageProvider {...data}>{props.children}</PageProvider>;
};
